import { resizeObservers } from '../utils/resizeObservers';
import { calculateDepthForNode } from './calculateDepthForNode';
import { cache as sizeCache } from './calculateBoxSize';
/**
 * Finds all active observations at a give depth
 *
 * https://drafts.csswg.org/resize-observer-1/#gather-active-observations-h
 */
var gatherActiveObservationsAtDepth = function (depth) {
    sizeCache.clear(); // clear target size cache
    resizeObservers.forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if (calculateDepthForNode(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};
export { gatherActiveObservationsAtDepth };
